namespace Nobox {

    @Serenity.Decorators.registerEditor()
    export class IntegrationPrevioder extends Serenity.Select2Editor<object, object> {

        constructor(hidden: JQuery) {
            super(hidden, null);
            this.addItem({
                id: "Bit.ly", text: "Bit.ly", source: {
                    AppEndpoint: "https://api-ssl.bitly.com/",
                    AppName:"Bit.ly"
                }
            });
        }
    }
}